import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	
	state: {
		companyInfo: {}
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/center/{centerId}/user/{username}/school-data')
				.then(({ data }) => {
					commit(types.STORE_COMPANY_INFO, data)
					return data;
				});
		},

		update({ commit }, { startHour, endHour, baseUrl, email, password, point }) {
			return axios.post('/center/{centerId}/user/{username}/devices-data', {
				StartHour: startHour,
				EndHour: endHour,
				BaseUrl: baseUrl,
				Email: email,
				Password: password,
				Lat: point.lat,
				Lng: point.lng,
			})
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_COMPANY_INFO](state, data) {
			state.companyInfo = data;
		},
		[types.RESET](state) {
			state.companyInfo = {};
		}
	},
}